import React from 'react';
import { withStyles, TextField, InputAdornment } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from './styles';

const PF2MSearchInput = ({
  value,
  variant,
  startIcon,
  size,
  onChange,
  disabled,
  classes,
  text,
  placeholder,
  textFieldProps,
  helperText,
  error,
}) => (
  <div className={classes.box}>
    {text && <p className={classes.labelTypeSelector}>{text}</p>}
    <TextField
      id="pf2m-search"
      type="text"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      variant={variant}
      size={size}
      classes={{ root: classes.root }}
      helperText={helperText}
      error={error}
      InputProps={{
        startAdornment: startIcon ? (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ) : null,
        ...textFieldProps,
      }}
    />
  </div>
);

PF2MSearchInput.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  startIcon: PropTypes.node,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  classes: PropTypes.object.isRequired,
  text: PropTypes.string,
  placeholder: PropTypes.string,
  textFieldProps: PropTypes.object,
  helperText: PropTypes.string,
  error: PropTypes.bool,
};

PF2MSearchInput.defaultProps = {
  value: '',
  onChange: () => {},
  disabled: false,
  size: 'small',
  variant: 'outlined',
  startIcon: false,
  text: null,
  placeholder: '',
  textFieldProps: {},
  helperText: '',
  error: false,
};

export default withStyles(styles)(PF2MSearchInput);
